import React, {
  useEffect,
} from 'react';
import Table from 'core/components/VirtualTable';
import {
  VirtualTableColumnDef as ColumnDef,
} from 'core/components/VirtualTable/types';
import {
  EncounterFinancialDetailsDTO,
  PatientEncounterFinancialDTO,
} from 'dtos';
import {
  useGetUnpaidEncounterBillingData,
} from 'views/EMR/hooks/billing';
import {
  withSuggestions,
} from 'views/EMR/Billing/utils';
import {
  paymentsEventChannel,
} from 'pages/Dashboard/services/eventChannels';

type Props = {
  patientId: number;
  suggestedData?: PatientEncounterFinancialDTO[];
  columns: ColumnDef<EncounterFinancialDetailsDTO>[];
};

export default function UnpaidEncounters({ patientId, columns, suggestedData }: Props) {
  const { data = {}, refetch } = useGetUnpaidEncounterBillingData(patientId);
  const encounters = withSuggestions(data.encounterFinancials ?? [], suggestedData);

  useEffect(() => {
    const unsubscribe = paymentsEventChannel.on('onPatientBalanceChange', () => {
      refetch();
    });

    return () => { unsubscribe(); };
  }, [patientId]);

  return (
    <Table<EncounterFinancialDetailsDTO>
      getRowId={(row) => row.encounterId}
      columns={columns}
      classes={{
        cell: '!bg-white',
        outerRow: '!w-full',
        scrollbarGutter: 'inherit',
        windowsClassName: '!w-full',
      }}
      emptySlot="All encounters are paid off in full."
      data={encounters}

    />
  );
}
